export const data = {
  education: [
    {
      title: "B.Tech (CSE) ",
      subTitle: "Lovely Professional University, Phagwara",
      description:"7.93 CGPA",
      dates: "2020-2023",
    },
    {
      title: "Diploma (CSE)",
      subTitle: "Lovely Professional University, Phagwara",
      description: "7.1 CGPA",
        dates: "2018-2020",
    },
    
  ], 
  
  
  
  
  
  experience: [
      {
        title: "Internship Program ",
        subTitle: "Highradius",
        description:
          "In this 2 month internship training in which I have worked on frontend development.",
          dates:"28 January - 13 April 2022"
      },
      
      {
        title: "JavaScript",
        subTitle: "Board Infinity",
        description:
          "This 2 months course covers the javascript from basic to advance level",
          dates:"1 May - 1 July 2022 "
      },
      {
        title: "Web Development Bootcamp ",
        subTitle: "Dr. Angela Yu (Udemy)",
        description:
          "In this online course I have learn about full-Stack Webdevelopemt and different tools of developemnt ",
          dates:"2023"
      },
      {
        title: "Web Technology",
        subTitle: "Oxo Solution",
        description:
          "Leaned about how webiste actully works on large scale",
          dates:" September 2019"
      },
    ],
    

    extracir: [
      {
        title: "Organisations",
        subTitle: "NSS(National Service Scheme) , Howard Smiles NGO",
        description:
          "Unit Leader(Aagaz) at NSS in 2023 , Promotion head at Howard Smiles in 2022",
          dates:"2019-2023",
      },
      
      {
        title: "Blood Donation Camp",
        subTitle: "",
        description:
          "Volunteered in Blood Donation Camp held in Lovely Professional University",
          dates:"2019,2021",
      },
      {
        title: "Road Safety Awareness",
        subTitle: "",
        description:
          "Participated in “Road Safety Awareness” organised by Honda",
          dates:"2020",
      },
      {
        title: "Polio Camp",
        subTitle: "",
        description:
          "Volunteered in Polio Camp held in Jalandhar City Railway Station",
          dates:"2020",
      },

      {
        title: "Cultual Event",
        subTitle: "",
        description:
          "I proudly represented Punjab, embodying its spirit, at Lovely Professional University's One India cultural event.",
          dates:"2022",
      },

      
    ],



  };